<script lang="ts" setup>
  import { App } from '@capacitor/app'
  import { SplashScreen } from '@capacitor/splash-screen'
  import { storeToRefs } from 'pinia'

  import { BngHeader, BngMobileNavFooter, BngToast } from './components'

  const { loading, toast, scroll } = storeToRefs(useUiStore())
  const { isFetching } = useAppInit()
  const config = useRuntimeConfig()

  const pageContent = useTemplateRef('pageContent')
  const router = useRouter()

  onMounted(() => {
    if (!import.meta.server) {
      scroll.value = true
    }
    loading.value = false
    if (!import.meta.server) {
      router.afterEach((to, from) => {
        if (from.name !== to.name) {
          pageContent.value?.scrollTo({ top: 0 })
        }
      })
      console.log(
        `%cVersion : %c${config.public.clientVersion}`,
        'color: #FFFFFF; font-size: 14px;',
        'color: #11d199; font-size: 14px; font-weight: bold;',
      )
    }

    if (config.public.isMobile) {
      App.addListener('appUrlOpen', (data: { url: string }) => {
        const slug = data.url.split('bookandgolf:/').pop()
        if (slug) {
          router.push({
            path: slug,
          })
        }
      })

      SplashScreen.hide()
    }
  })

  useHead({
    title: 'Bookandgolf',
  })

</script>

<template>
  <div class="l-default">
    <Loader :displayed="isFetching || loading" />
    <BngHeader />
    <BngToast
      :content="toast"
      @close="() => null"
    />
    <div
      id="layout-observer-root"
      ref="pageContent"
      class="page-content"
      :class="{ 'no-scroll': !scroll }"
    >
      <slot />
    </div>
    <div id="modal-booking" />
    <div id="modal" />
    <div id="reservation-banner" />
    <BngMobileNavFooter />
  </div>
</template>

<style scoped>
.l-default {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100 - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100 - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  flex-direction: column;
  background-color: #eef0f1;

  .page-content {
    position: relative;
    display: flex;
    overflow: hidden auto;
    flex: 1 1 auto;
    flex-direction: column;
  }

  .no-scroll {
    overflow: hidden;
    height: calc(100% - 3.25em);
  }

  @media all and (width <= 360px) {
    font-size: 0.85em;
  }
}
</style>
